"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PubSub = void 0;

var _uuid = require("uuid");

class PubSub {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventMap = new Map();
  subscribe = (event, callback) => {
    if (!this.eventMap.has(event)) {
      this.eventMap.set(event, new Map());
    }

    const listenersMap = this.eventMap.get(event);
    const listenerId = (0, _uuid.v4)();
    listenersMap?.set(listenerId, callback);
    return () => {
      listenersMap?.delete(listenerId);

      if (listenersMap?.size === 0) {
        this.eventMap.delete(event);
      }
    };
  };
  publish = (name, payload) => {
    const listeners = this.eventMap.get(name);

    if (listeners) {
      listeners.forEach(callback => callback(payload));
    }
  };
}

exports.PubSub = PubSub;